import {RowCountFacts} from '../copilotAnalytics.types';

/**
 * Appends factual row-count guidance so the LLM does not confuse requested cap (e.g. count: 10)
 * with how many rows the API actually returned.
 */
export default function appendRowCountFactsToToolResultMessage(
  baseMessage: string,
  facts: RowCountFacts,
): string {
  const {rowCount, requestedMaxRows} = facts;
  const rowFact = `For your reply: the returned analytics has ${rowCount} row(s).`;

  if (requestedMaxRows != null && rowCount < requestedMaxRows) {
    return `${baseMessage} ${rowFact} The query requested up to ${requestedMaxRows} row(s), but only ${rowCount} matching value(s) exist in this date range—tell the user there are ${rowCount}, not ${requestedMaxRows}.`;
  }

  return `${baseMessage} ${rowFact}`;
}
